import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-media-selector-dialog',
  templateUrl: './media-selector-dialog.component.html',
  styleUrls: ['./media-selector-dialog.component.scss']
})
export class MediaSelectorDialogComponent {
  mediaList: any[] = [];
  selectedMedia: Set<any> = new Set();

  constructor(
    public dialogRef: MatDialogRef<MediaSelectorDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { patientMedia: any[] }
  ) {
    const allMedia = data.patientMedia || [];
    // Filter out images that have an originalPdfUrl (keep the PDF instead)
    this.mediaList = allMedia.filter(media => {
      const isImage = media.mediaType?.startsWith('image/');
      const hasOriginalPdf = !!media.originalPdfUrl;
      // Exclude if it's an image with an originalPdfUrl
      return !(isImage && hasOriginalPdf);
    });
    console.log('[MEDIA SELECTOR] Available media documents:', {
      originalCount: allMedia.length,
      filteredCount: this.mediaList.length,
      excluded: allMedia.length - this.mediaList.length,
      media: this.mediaList
    });
  }

  isImage(media: any): boolean {
    return media.mediaType?.startsWith('image/');
  }

  getMediaIcon(media: any): string {
    if (media.mediaType === 'application/pdf') {
      return 'picture_as_pdf';
    } else if (media.mediaType?.startsWith('video/')) {
      return 'videocam';
    } else {
      return 'insert_drive_file';
    }
  }

  isSelected(media: any): boolean {
    return this.selectedMedia.has(media);
  }

  toggleMedia(media: any, event?: Event): void {
    if (event) {
      event.stopPropagation();
    }
    if (this.selectedMedia.has(media)) {
      this.selectedMedia.delete(media);
    } else {
      this.selectedMedia.add(media);
    }
  }

  get selectedCount(): number {
    return this.selectedMedia.size;
  }

  send(): void {
    if (this.selectedMedia.size === 0) {
      return;
    }
    this.dialogRef.close(Array.from(this.selectedMedia));
  }

  close(): void {
    this.dialogRef.close();
  }
}

